import { makeStyles, shorthands } from '@fluentui/react-components';

export const useStyle = makeStyles({
  overflow: {
    display: 'block',
    ...shorthands.overflow('hidden'),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});
